import { AxiosPromise } from 'axios';
import request from '@/utils/request';

import { SpuRelevantDataVo } from './type';

/**
 * 根据游戏id 查询对应的spu 主要针对于游戏主页、offer页的spu查询
 */
export const getSpuRelevantDataVo = (params: { entityId: string | number }): AxiosPromise<SpuRelevantDataVo[]> => {
  return request({
    url: '/product/urlMapping/game-service/getSpuRelevantDataVo',
    method: 'get',
    params
  });
};
